
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.step-indicators {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  max-width: 42rem
}

.step-indicator__step {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%
}

.step-indicator__step.active .step-indicator__button, .step-indicator__step.active .step-indicator__number, .step-indicator__button, .step-indicator__number, .step-indicator__checked {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  display: flex;
  height: 2rem;
  width: 2rem;
  min-width: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 0px;
  background-color: var(--green-guarantee-main);
  color: var(--neutral-white);
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  line-height: 1
}

.step-indicator__button, .step-indicator__number {
  border-width: 2px;
  border-style: solid;
  border-color: var(--green-guarantee-main);
  background-color: var(--neutral-transparent);
  color: var(--green-guarantee-main)
}

.step-indicator__button {
  cursor: pointer
}

.step-indicator__checked outline-icon {
  color: var(--neutral-white)
}

.step-indicator__label {
  text-align: center;
  font-size: var(--fs-base);
  line-height: var(--lh-base)
}

.step-panel {
  display: none;
}

.step-panel.active {
  display: block
}

.step-indicator__circle {
  display: flex;
  width: 100%;
  align-items: center
}

.step-indicator__line {
  display: flex;
  width: 100%;
  background-color: var(--gray-professional-main);
  height:1px;
}

.step-indicator__line.transparent {
  background-color: var(--neutral-transparent)
}

::slotted([slot='step-panels']) {
  display: none
}

::slotted(.active) {
  display: block
}
`;